<script setup lang="ts">
  import { cn } from "@/lib/utils"
  import type { HTMLAttributes } from "vue"

  const props = defineProps<{
    class?: HTMLAttributes["class"]
  }>()
</script>

<template>
  <div
    :class="cn('body-text pb-4 pt-3 first:pt-0 last:pb-0', props.class)"
    data-testid="card-content"
  >
    <slot />
  </div>
</template>
